import React from 'react';
import ArrayInput from './ArrayInput';

const SkillsSection = ({
  jobData,
  newSkillRequired,
  setNewSkillRequired,
  newSkillPreferred,
  setNewSkillPreferred,
  handleSkillRequiredAdd,
  handleSkillRequiredRemove,
  handleSkillPreferredAdd,
  handleSkillPreferredRemove
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Skills</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ArrayInput
          label="Required Skills"
          arrayName="skills_required"
          items={jobData.skills_required}
          newValue={newSkillRequired}
          onValueChange={setNewSkillRequired}
          onAdd={handleSkillRequiredAdd}
          onRemove={handleSkillRequiredRemove}
          placeholder="Add a required skill..."
        />

        <ArrayInput
          label="Preferred Skills"
          arrayName="skills_preferred"
          items={jobData.skills_preferred}
          newValue={newSkillPreferred}
          onValueChange={setNewSkillPreferred}
          onAdd={handleSkillPreferredAdd}
          onRemove={handleSkillPreferredRemove}
          placeholder="Add a preferred skill..."
        />
      </div>
    </div>
  );
};

export default SkillsSection;